module.exports = __webpack_public_path__ + "img/image9.2e9bfd8e.jpg";